export default ({
  state: {
    entryPoint: {
      previousLocation: 'map',
      routeId: '',
      sublineId: '',
      previousIsFavorites: false
    },
  },
  mutations: {
    SET_ENTRY_POINT(state, value) {
      state.entryPoint = value
    }
  },
  getters: {
    entryPointGetters: state => state.entryPoint
  },
  actions: {
    entryPointAction({commit},data) {
      commit('SET_ENTRY_POINT', data)
    },
  }
})
